import { PagingService } from './../../../../../shared/Services/PagingService';
import { QueryModel } from './../../../../../shared/Models/queryModel';
import { RequestService } from './../../services/request.service';
import { Component, OnInit } from '@angular/core';
import { FollowRequestComponent } from '../follow-request/follow-request.component';
import { NbDialogService } from '@nebular/theme';
import { PagingModel } from '../../../../../shared/Models/PagingModel';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'workflow-all-requests',
  templateUrl: './all-requests.component.html',
  styleUrls: ['./all-requests.component.scss'],
})
export class AllRequestsComponent implements OnInit {

  result: any[];
  queryModel: QueryModel;
  componentModel: PagingModel;
  finishLoadingRequest = false;

  constructor(private service: RequestService,
    private dialogService: NbDialogService,
    private paging: PagingService) {
    this.queryModel = new QueryModel();
   }

  ngOnInit() {
    this.componentModel = new PagingModel();
    this.loadRequests();
  }

  loadRequests() {
    this.finishLoadingRequest = false;

    this.service.get(this.componentModel.query).subscribe((data: any) => {

      this.componentModel.responseObj = data.result;
      this.componentModel.responseData = data;
      this.componentModel.totalPages = data.totalPages;
      this.componentModel.pager = Array.from(
        { length: data.totalPages },
        (v, k) => k + 1,
      );
    //  this.componentModel.pager.slice(this.componentModel.currentPage - 1, this.componentModel.currentPage + 9);

      this.finishLoadingRequest = true;
    });
  }
  Detail(id: number, unitTypeId: number, criteriaType: number, title: string) {

  }
  follow(item: any[], isComplete: boolean) {
    this.dialogService.open(FollowRequestComponent, { context: { item: item, complete: isComplete } });
  }
  setPage(page: number) {
    this.finishLoadingRequest = false;
    this.paging.setPage(page, this.componentModel, this.service);
    this.finishLoadingRequest = true;
  }

}
